
  <h3>{{data.head}}</h3>
    <hr>
    <p [innerHtml]="data.body.replace('##', data.item? '<strong>'+data.item+'</strong>': 'this item')"> </p>
    <div class="row a-center">
      <app-select-field class="col-9" [label]="data.head" [options]="data?.options"
      [control]="assignUser" valueKey="userId" optionKey="optionName" ></app-select-field> 
      <!-- [multiple]="!data.single" comment due to OA-125 -->
      <div class="col-3">
        <button mat-raised-button (click)="submit()" color="primary">Submit</button>
        <!-- <button mat-button (click)="onNoClick()" cdkFocusInitial class="ml-2">Cancel</button> -->
      </div>
    </div>
    <button class="close" mat-icon-button (click)="onNoClick()"><mat-icon>close</mat-icon></button>
    